import { render, staticRenderFns } from "./boa-hora-schedule.vue?vue&type=template&id=b5ccc516&scoped=true&"
import script from "./boa-hora-schedule.vue?vue&type=script&lang=ts&"
export * from "./boa-hora-schedule.vue?vue&type=script&lang=ts&"
import style0 from "./boa-hora-schedule.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./boa-hora-schedule.vue?vue&type=style&index=1&id=b5ccc516&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ccc516",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox})
